import { Point, Polyline } from "esri/geometry";
import * as geometryEngine from 'esri/geometry/geometryEngine'
import Query = require("esri/rest/support/Query");
import MapView = require("esri/views/MapView");
import * as otherLayers from "../../data/Layers/otherLayers";
import ToolBar from "../Toolbar";
import ToolButton from "./toolButton";

// vanPicsTool

export default class VanPicsTool extends ToolButton {
  private eventHandler: IHandle;
  private layerDisplay: boolean;
  private dataSrc: string;

  constructor(viewIn: MapView, toolbarIn: ToolBar) {
    super(viewIn, toolbarIn);
  }

  deactivateTool() {
    // console.log("measureDistanceTool deactivateTool")
    if (this.eventHandler) {
      this.eventHandler.remove();
    }
    document.body.style.cursor = "default";
    otherLayers.vanPicsRoadsLayer.visible = this.layerDisplay;
    otherLayers.vanPicsIDOTRoadsLayer.visible = this.layerDisplay;
  }

  // Put widgets on map view
  activateTool(event: any) {
    // console.log("VanPicsTool start")
    try {
      this.iconDiv = event.currentTarget;
      var chkTitle = this.iconDiv.title;
      this.dataSrc = "Pathway";
      
      if (chkTitle == "IDOT Van Pictures") {
        this.dataSrc = "IDOT";
        this.layerDisplay = otherLayers.vanPicsIDOTRoadsLayer.visible; // save for exiting tool
      } else {
        this.layerDisplay = otherLayers.vanPicsRoadsLayer.visible; // save for exiting tool
      }
      

      if (this.toolbar && this.view) {
        this.toolbar.setActiveTool(this as ToolButton);
        this.view.focus();
        document.body.style.cursor = "crosshair";
        otherLayers.vanPicsRoadsLayer.visible = true;
        this.eventHandler = this.view.on("click", mouseEvent => {
          mouseEvent.stopPropagation();
          document.body.style.cursor = "wait";

          const query = new Query({
            // objectIds: [189280],
            geometry: mouseEvent.mapPoint,
            spatialRelationship: "intersects",
            distance: 50,
            returnM: true,
            units: "meters",
            outFields: ["*"],
            returnGeometry: true
          });
          
          if (this.dataSrc == "IDOT") {
            // console.log("start raods query");
            otherLayers.vanPicsIDOTRoadsLayer
              .queryFeatures(query)
              .then(featureSet => {
                if (featureSet.features.length > 0) {
                  let closestDist = 999999;
                  let closestIndex = 0;
                  featureSet.features.forEach((value, index) => {
                    const dist = geometryEngine.distance(mouseEvent.mapPoint, value.geometry, "meters");
                    if (dist < closestDist) {
                      closestDist = dist;
                      closestIndex = index;
                    }
                  });

                  // https://intraapps.dot.illinois.gov/VanPics/VanPics.aspx?inv=084  20662 000000&sta=0.75&name=Veterans Pkwy

                  const collName = featureSet.features[closestIndex].attributes.ROUTENAME as string;
                  const name = featureSet.features[closestIndex].attributes.STREETNAME;

                  const inv = collName.substr(0,3) + "  " + collName.substr(4,5) + (collName.substr(9,1) !== "_" ? collName.substr(9,1) : " ") + collName.substr(10,6);
                  let dir = collName.substr(19,1);
                  if (dir == "" || dir == "_") {
                    dir = collName.substr(18,1);
                    if (dir == "" || dir == "_") {
                      dir = "I";
                    }
                  }
                  const routeYear = featureSet.features[closestIndex].attributes.RouteYear;  
                  const line = featureSet.features[closestIndex].geometry as Polyline;
                  const nearestPointResult = geometryEngine.nearestCoordinate(line, mouseEvent.mapPoint);

                  let path = 0;
                  let vertex = nearestPointResult.vertexIndex;
                  if (line.paths.length > 1 && nearestPointResult.vertexIndex >= line.paths[0].length) {
                    // console.error(" Poly line has more than 1 path " + line.paths.length + " vertexIndex " + nearestPointResult.vertexIndex );
                    for (let i=1; i<line.paths.length; i++) {
                      vertex = vertex - line.paths[i-1].length;
                      path = i;
                      // console.log("Path " + i + " length = " + line.paths[i].length);
                      if (vertex < line.paths[i].length) {
                        break;
                      }
                    }
                  }
                  // console.log("found path " + path + " vertex = " + vertex);
                  const begPt = new Point({
                    x: line.paths[path][vertex][0],
                    y: line.paths[path][vertex][1],
                    m: line.paths[path][vertex][2],
                    spatialReference: line.spatialReference
                  });
                  const xPnt = line.paths[path][vertex][0];
                  const yPnt = line.paths[path][vertex][1];
                  // console.log("nearest point lat " + latPnt + " lon " + lonPnt + " m " + begPt.m);
                  const dist0 = geometryEngine.distance(begPt, nearestPointResult.coordinate, "miles");
                  const sta = begPt.m + dist0;
                  let url = ""; 
                  let checkYear = parseInt(routeYear);
                  if (checkYear < 2025) {
                    url ="/VanPics/VanPics.html?inv=" + inv + "&sta=" + sta.toFixed(3) + "&dir="+dir+"&year="+routeYear+"&collName="+collName+"&name="+name;
                  } else {
                    url ="https://pathweb.pathwayservices.com/il" + "/search?sectionfilter=[direction="+dir+"]&spatialfilter=[x=" + xPnt + ",y=" + yPnt + ",radiusmeters=20.0,srid=3785]";
                  }
                  
                  // "https://intraapps.dot.illinois.gov/VanPics/VanPics.aspx?inv=" + inv + "&sta=" + sta.toFixed(3);
                  // console.log("Van Pics Url = ", url);
  
                  window.open(url, "vanPics");
                  this.toolbar.setPanAsActiveTool();
                } else {
                  console.log("no roads retruend");
                  document.body.style.cursor = "crosshair";
                  alert("No road with Van Pics found. Try again."); 
                }
              })
              .catch(reason => {
                this.toolbar.setPanAsActiveTool();
                console.error("Error in Van Pics tool ", reason);
              });
          }
          else {
            // console.log("start raods query");
            otherLayers.vanPicsRoadsLayer
              .queryFeatures(query)
              .then(featureSet => {
                if (featureSet.features.length > 0) {
                  let closestDist = 999999;
                  let closestIndex = 0;
                  featureSet.features.forEach((value, index) => {
                    const dist = geometryEngine.distance(mouseEvent.mapPoint, value.geometry, "meters");
                    if (dist < closestDist) {
                      closestDist = dist;
                      closestIndex = index;
                    }
                  });

                  // https://intraapps.dot.illinois.gov/VanPics/VanPics.aspx?inv=084  20662 000000&sta=0.75&name=Veterans Pkwy

                  const collName = featureSet.features[closestIndex].attributes.ROUTENAME as string;
                  const name = featureSet.features[closestIndex].attributes.STREETNAME;

                  const inv = collName.substr(0,3) + "  " + collName.substr(4,5) + (collName.substr(9,1) !== "_" ? collName.substr(9,1) : " ") + collName.substr(10,6);
                  let dir = collName.substr(19,1);
                  if (dir == "" || dir == "_") {
                    dir = collName.substr(18,1);
                    if (dir == "" || dir == "_") {
                      dir = "I";
                    }
                  }
                  const routeYear = featureSet.features[closestIndex].attributes.RouteYear;  
                  const line = featureSet.features[closestIndex].geometry as Polyline;
                  const nearestPointResult = geometryEngine.nearestCoordinate(line, mouseEvent.mapPoint);

                  let path = 0;
                  let vertex = nearestPointResult.vertexIndex;
                  if (line.paths.length > 1 && nearestPointResult.vertexIndex >= line.paths[0].length) {
                    // console.error(" Poly line has more than 1 path " + line.paths.length + " vertexIndex " + nearestPointResult.vertexIndex );
                    for (let i=1; i<line.paths.length; i++) {
                      vertex = vertex - line.paths[i-1].length;
                      path = i;
                      // console.log("Path " + i + " length = " + line.paths[i].length);
                      if (vertex < line.paths[i].length) {
                        break;
                      }
                    }
                  }
                  // console.log("found path " + path + " vertex = " + vertex);
                  const begPt = new Point({
                    x: line.paths[path][vertex][0],
                    y: line.paths[path][vertex][1],
                    m: line.paths[path][vertex][2],
                    spatialReference: line.spatialReference
                  });
                  const xPnt = line.paths[path][vertex][0];
                  const yPnt = line.paths[path][vertex][1];
                  // console.log("nearest point lat " + latPnt + " lon " + lonPnt + " m " + begPt.m);
                  const dist0 = geometryEngine.distance(begPt, nearestPointResult.coordinate, "miles");
                  const sta = begPt.m + dist0;
                  let url = ""; 
                  let checkYear = parseInt(routeYear);
                  if (checkYear < 2025) {
                    url ="/VanPics/VanPics.html?inv=" + inv + "&sta=" + sta.toFixed(3) + "&dir="+dir+"&year="+routeYear+"&collName="+collName+"&name="+name;
                  } else {
                    url ="https://pathweb.pathwayservices.com/il" + "/search?sectionfilter=[direction="+dir+"]&spatialfilter=[x=" + xPnt + ",y=" + yPnt + ",radiusmeters=20.0,srid=3785]";
                  }
                  
                  // "https://intraapps.dot.illinois.gov/VanPics/VanPics.aspx?inv=" + inv + "&sta=" + sta.toFixed(3);
                  // console.log("Van Pics Url = ", url);
  
                  window.open(url, "vanPics");
                  this.toolbar.setPanAsActiveTool();
                } else {
                  console.log("no roads retruend");
                  document.body.style.cursor = "crosshair";
                  alert("No road with Van Pics found. Try again."); 
                }
              })
              .catch(reason => {
                this.toolbar.setPanAsActiveTool();
                console.error("Error in Van Pics tool ", reason);
              });
          }
          
        });
      }
    } catch (error) {
      console.error("Error: in VanPicsTool " + +error.message);
      this.toolbar.setPanAsActiveTool();
    }
  }
}
